import styled from 'styled-components'
import Flex from 'components/priority/Flex/Flex'
import colors from 'utils/styling/colors'

export const ToastAction = styled(Flex)`
  &:hover {
    background: ${colors('white', 10)};
  }
`
